import { createAction } from 'redux-act'

import * as reports from '../../api/reports'

export const getSalesAudit = createAction('GET_SALES_AUDIT', reports.salesAudit)
